// @flow

import { 
  type UserInputValidationError, 
  type UserInputValidatorArgs, 
  onlyWhenSupport, 
  VALID,
} from '@tectonics/prs/validation';

import { validatePeruvianCity } from './peruvian-city';
import { validatePeruvianState } from './peruvian-state';
import { validatePeruvianZipcode } from './peruvian-zipcode';
import { validatePeruvianAddress } from './peruvian-address';
import { validatePeruvianDocument } from './peruvian-document';
import { validatePeruvianPhoneNumber } from './peruvian-phone-number';
import { validatePeruvianStreetNumber } from './peruvian-street-number';

import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);

  switch (userInputName) {
    case 'peruvianDocument':
      return onlyWhen('field_peruvian_document') && validatePeruvianDocument(userInputValue);

    case 'peruvianPhoneNumber':
      return onlyWhen('field_peruvian_phone_number') && validatePeruvianPhoneNumber(userInputValue);

    case 'peruvianZipcode':
      return onlyWhen('field_peruvian_zipcode') && validatePeruvianZipcode(userInputValue);

    case 'peruvianState':
      return onlyWhen('field_peruvian_state') && validatePeruvianState(userInputValue);

    case 'peruvianCity':
      return onlyWhen('field_peruvian_city') && validatePeruvianCity(userInputValue);

    case 'peruvianAddress':
      return onlyWhen('field_peruvian_address') && validatePeruvianAddress(userInputValue);

    case 'peruvianStreetNumber':
      return onlyWhen('field_peruvian_street_number') && validatePeruvianStreetNumber(userInputValue);

    default:
      return VALID;
  }
}
